import { useEffect } from "react";
import UniBtn, { UniBtnPack } from "./UniBtn";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_extract_editorjs_renderable_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update, _zzyourmap_routing_routeState_to_path, _zzyourmap_routing_static_pages_keys, _zzyourmap_routing_tab_keys } from "../utils/zz/zz-yourmap-routing";
import { _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
import UniPair from "./UniPair";
import UniLink from "./UniLink";


// DEFAULT COMPONENT
const YourmapSectionHomeStuff = (props) => {
  const {

  } = props.appPack;
  _zzyourmap_routing_browser_title_update('');
  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="yourmap__article__title-and-subtitle">
            <div className="uu-gap-standalone-1rem"></div>
            <h2>Zašto naše mape?</h2>
            {/*<p>Sve što vam je potrebno za savršeno putovanje</p>*/}
            <p>Ručno crtane mape koje na jednostavan i lep način izdvajaju ono najvažnije u svakoj destinaciji.</p>
          </div>
          <div className="yourmap__grid yourmap__grid--items-w-1-3">
            <div className="xi">
              <div className="yourmap__card yourmap__card--zasto uu-shadow-alien-fluent2-tile-shadow">
                <div className="yourmap__card__heading-row">
                  <div className="yourmap__card__icon-wrap">
                    <i className="fa fa-eye"></i>
                  </div>
                  <b>Jasno i pregledno</b>
                </div>
                <span>Prikazujemo samo ono što zaista vredi posetiti — bez nepotrebnog šuma i zbunjujućih detalja.</span>
              </div>
            </div>
            <div className="xi">
              <div className="yourmap__card yourmap__card--zasto uu-shadow-alien-fluent2-tile-shadow">
                <div className="yourmap__card__heading-row">
                  <div className="yourmap__card__icon-wrap">
                    <i className="fa fa-paint-brush"></i>
                  </div>
                  <b>Unikatan dizajn</b>
                </div>
                <span>Svaka mapa je ručno ilustrovana i osmišljena da odražava karakter i duh same destinacije.</span>
              </div>
            </div>
            <div className="xi">
              <div className="yourmap__card yourmap__card--zasto uu-shadow-alien-fluent2-tile-shadow">
                <div className="yourmap__card__heading-row">
                  <div className="yourmap__card__icon-wrap">
                    <i className="fa fa-map-marker"></i>
                  </div>
                  <b>Praktično za turiste</b>
                </div>
                <span>Jedan pogled — sve lokacije na dohvat ruke. Bez gubljenja vremena, odmah znate kuda idete.</span>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-32px"></div>
          <div className="yourmap__grid uu-gaps-m-1rem222 yourmap__grid--gaps-1rem yourmap__grid--items-w-1-1">
            <div className="xi">
              <div className="yourmap__card yourmap__card--subscribe">
                <h3>Zapratite nas</h3>
                <p>Pratite nas na društvenim mrežama i saznajte prvi o najnovijim mapama</p>
                <div className="yourmap__social">
                  <div className="uu-vector uu-vector--row uu-vector--wrap uu-vector--center">
                    <div className="yourmap__social__btn-container">
                      <UniBtn
                        inline
                        circle
                        outline_NE
                        tooltip="Follow as on facebook"
                        i="fa fa-facebook-square"
                        extraClass="yourmap__theme__custom-btn-social"
                      />
                    </div>
                    <div className="yourmap__social__btn-container">
                      <UniBtn
                        inline
                        circle
                        outline_NE
                        tooltip="Follow as on X"
                        i="fa fa-twitter"
                        extraClass="yourmap__theme__custom-btn-social"
                      />
                    </div>
                    <div className="yourmap__social__btn-container">
                      <UniBtn
                        inline
                        circle
                        outline_NE
                        tooltip="Follow as on LinkedIn"
                        i="fa fa-linkedin"
                        extraClass="yourmap__theme__custom-btn-social"
                      />
                    </div>
                    <div className="yourmap__social__btn-container">
                      <UniBtn
                        inline
                        circle
                        outline_NE
                        tooltip="Follow as on instagram"
                        i="fa fa-instagram"
                        extraClass="yourmap__theme__custom-btn-social"
                      />
                    </div>
                    <div className="yourmap__social__btn-container">
                      <UniBtn
                        inline
                        circle
                        outline_NE
                        tooltip="Follow as on YouTube"
                        i="fa fa-youtube-play"
                        extraClass="yourmap__theme__custom-btn-social"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*
            <div className="xi">
              <div className="yourmap__card yourmap__card--subscribe">
                <h3>Budite u toku sa novostima</h3>
                <p>subscribe</p>
              </div>
            </div>
            */}
          </div>
        </div>
      </section>
    </>
  );
};

export default YourmapSectionHomeStuff;